import { Button } from 'primereact/button';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import { useEffect, useRef, useState, useCallback } from 'react';
import { endpointGoogleServiceAccountEndpointGET } from '~/api/def/endpoints/googleServiceEmailEndpoint';

export type MessageComponentProps = {
  msgText: string;
};

export default function MessageComponent({ msgText }: MessageComponentProps) {
  const [googleServiceAccountEmail, setGoogleServiceAccountEmail] =
    useState<string>('');
  const [googleServiceAccountLoading, setGoogleServiceAccountLoading] =
    useState(false);
  const toast = useRef<Toast>(null);

  useEffect(() => {
    setGoogleServiceAccountLoading(true);
    endpointGoogleServiceAccountEndpointGET()
      .then((res) => {
        setGoogleServiceAccountEmail(res?.data.serviceAccountEmail || '');
      })
      .catch(() => {
        toast.current?.show({
          severity: 'error',
          detail: 'Something went wrong while fetching service account email.',
        });
      })
      .finally(() => {
        setGoogleServiceAccountLoading(false);
      });
  }, []);

  const handleEmailCopy = useCallback(() => {
    navigator.clipboard
      .writeText(googleServiceAccountEmail)
      .then(() => {
        toast.current?.show({
          severity: 'success',
          detail: 'Email copied to clipboard.',
        });
      })
      .catch(() => {
        toast.current?.show({
          severity: 'error',
          detail: 'Failed to copy text.',
        });
      });
  }, [googleServiceAccountEmail]);

  return (
    <>
      <Toast ref={toast} />
      <div
        className="px-3 py-2 mt-2"
        style={{
          background: '#cce5ff',
          border: 'solid #b8daff',
          borderWidth: '1px',
          color: '#004085',
          borderRadius: '4px',
        }}
      >
        {googleServiceAccountLoading ? (
          <Skeleton
            pt={{
              root: {
                style: {
                  backgroundColor: '#80B1E1',
                },
              },
            }}
            height="2.5rem"
          />
        ) : (
          <div className="flex justify-content-between w-full">
            <div className="flex align-items-center justify-content-between gap-2">
              <i className="pi pi-share-alt" style={{ fontSize: '1.2rem' }}></i>
              <div>
                <span>{msgText}</span>
                <span className="font-semibold">
                  {googleServiceAccountEmail}
                </span>
              </div>
            </div>
            <Button
              icon="pi pi-copy"
              outlined
              aria-label="copy email"
              size="small"
              onClick={handleEmailCopy}
            />
          </div>
        )}
      </div>
    </>
  );
}
